import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getMenuItems } from 'src/api/getMenuItems/getMenuItems';
import type { IMenuItem, TMenuItemType } from 'src/types/menu.types';
import { QueryKeys } from 'src/hooks/QueryKeys';
import { formatItems } from './formatItems/formatItems';

export const useItems = (
  searchQuery?: string,
  limit: number = 15,
  type?: TMenuItemType[],
  options?: UseInfiniteQueryOptions<IMenuItem[]>,
  ranges?: string[],
) => {
  const { showSnackbar } = useSnackbar();

  return useInfiniteQuery<IMenuItem[]>({
    queryKey: [QueryKeys.items, searchQuery, type, ranges],
    queryFn: async ({ pageParam = '' }) => {
      const menuItems = await getMenuItems(pageParam, searchQuery, `${limit}`, type, ranges);

      return formatItems(menuItems.data);
    },
    getNextPageParam: (menuItems) => menuItems[menuItems.length - 1]?.itemId,
    refetchOnWindowFocus: false,
    onError: () => showSnackbar({ status: SnackbarStatus.ERROR, message: 'Internal Server Error' }),
    ...options,
  });
};

export default useItems;
